import { render, staticRenderFns } from "./MultiSelectChips.vue?vue&type=template&id=33002b71&scoped=true"
import script from "./MultiSelectChips.vue?vue&type=script&lang=js"
export * from "./MultiSelectChips.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MultiSelectChips.vue?vue&type=style&index=1&id=33002b71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33002b71",
  null
  
)

export default component.exports